import React from "react";
import { useSelector } from "react-redux";
import { toLocalDateTime } from "../../utils/DateUtil";
import "./Visitor_in_out.css";

const Main = () => {

    const timeInVisitors = useSelector((state) => state.dashboard.data.visitorsIn);
    const timeOutVisitors = useSelector((state) => state.dashboard.data.visitorsOut);


    return (
        <>
            <div className="visitor-table-row">
                {/* Time-in Visitors Table */}
                <div className="visitor-table-container shadow-sm p-4 mb-4 col-md-6">
                    <h3 className="visitor-heading">Time-in Visitors</h3>
                    <div className="table-wrapper">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Sr.</th>
                                    <th>Visitor Name</th>
                                    <th>Time-in</th>
                                </tr>
                            </thead>
                            <tbody>
                                {timeInVisitors && timeInVisitors.length > 0 ? (
                                    timeInVisitors.map((visitor, index) => (
                                        <tr key={visitor.id}>
                                            <td>{index + 1}</td>
                                            <td>{visitor.visitorname}</td>
                                            <td>{toLocalDateTime(visitor.timein)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No time-in visitors found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Time-out Visitors Table */}
                <div className="visitor-table-container shadow-sm p-4 mb-4 col-md-6">
                    <h3 className="visitor-heading">Time-out Visitors</h3>
                    <div className="table-wrapper">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Sr.</th>
                                    <th>Visitor Name</th>
                                    <th>Time-out</th>
                                </tr>
                            </thead>
                            <tbody>
                                {timeOutVisitors && timeOutVisitors.length > 0 ? (
                                    timeOutVisitors.map((visitor, index) => (
                                        <tr key={visitor.id}>
                                            <td>{index + 1}</td>
                                            <td>{visitor.visitorname}</td>
                                            <td>{toLocalDateTime(visitor.timeout)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No time-out visitors found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main;
